<template>
  <div>
    <v-tabs
      v-model="index"
      background-color="primary"
      height="40"
      hide-slider
      next-icon="fa-caret-right"
      prev-icon="fa-caret-left"
    >
      <v-tab v-for="tab in tabs" :key="tab.uuid" @click.middle="close(tab)" @click.right.prevent="">
        <v-icon v-if="tab.icon">{{ tab.icon }}</v-icon>
        <div v-else class="d-flex justify-center align-center" style="z-index:2;">
          <template v-if="displayCloseIcon(tab)">
            <span> {{ $t(tab.name) }}</span>
            <v-icon class="pa-2" right x-small @click="close(tab)">fa-times</v-icon>
          </template>
          <template v-else>
            <span style="color:white;">{{ $t(tab.name) }}</span>
          </template>
        </div>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="index">
      <v-tab-item v-for="tab in tabs" :key="tab.uuid" :reverse-transition="false" :transition="false">
        <component :is="tab.component" :ref="tab.uuid" :index="index" :tab="tab" :tabs="tabs" @update="update" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { Types } from "../../../store/modules/application"
import { Types as TypesLoading } from "@/store/modules/loading"

export default {
  name: "Dashboard",
  computed: {
    tabs: {
      get() {
        return this.$store.state.application.tabs
      },
      set(value) {
        this.$store.dispatch(Types.actions.UPDATE_TABS, value)
      },
    },
    index: {
      get() {
        return this.$store.state.application.index
      },
      set(value) {
        this.$store.dispatch(Types.actions.UPDATE_INDEX, value)
      },
    },
  },
  methods: {
    displayCloseIcon(current) {
      return this.index === this.tabs.findIndex(tab => tab.uuid === current.uuid)
    },
    // Update props
    update(payload) {
      // Save the tabs and index on localStorage
      this[payload.prop] = payload.value
    },
    close(tab) {
      // TODO this code seams to never be used
      this.$store.commit(TypesLoading.mutations.LOADING_NO)
      tab = JSON.parse(JSON.stringify(tab))
      // Pay attention to this weird index

      if (this.$refs[tab.uuid]) {
        this.$refs[tab.uuid][0].remove(tab.uuid)
      }
    },
  },
}
</script>
